import React from 'react'

import FlexAppHeader from '@jimmyboys/liita-ui/dist/components/FlexAppHeader'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'

import LastUpdate from 'components/general/LastUpdate/LastUpdate'
import { useInbox } from 'store'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import useSectionTitle from 'hooks/useSectionTitle'
import { useRecoilValue } from 'recoil'
import { lastFetchInboxUpdate } from 'store'

import styles from './AsideHeader.module.sass'

const AsideHeader = () => {
	const { i18n } = useGlobal()
	const title = useSectionTitle(i18n)
	const {
		reloadInbox,
		setForceInboxUpdate,
		expandedInbox,
		inboxHasNewData,
	} = useInbox()

	const lastInboxUpdateTimestamp = useRecoilValue(lastFetchInboxUpdate)
	return (
		<FlexAppHeader className={styles['header']} sticky>
			{expandedInbox ? (
				<HStack
					className={styles['inbox-header-content']}
					align='center'
					wrap='nowrap'
					gap='xsmall'
					justify='space-between'
				>
					<VStack>
						<small>
							<strong>
								{inboxHasNewData
									? i18n`New items. Please refresh.`
									: i18n`Notifications`}
							</strong>
						</small>
						<small className='ellipsis'>
							{i18n`Last update`}:{' '}
							{<LastUpdate value={lastInboxUpdateTimestamp} />}
						</small>
					</VStack>
					<div>
						<ActionButton
							primary={inboxHasNewData}
							icon='reload'
							className={styles['refresh-button']}
							onClick={() => {
								reloadInbox()
								setForceInboxUpdate(true)
							}}
						></ActionButton>
					</div>
				</HStack>
			) : (
				<h5 className={styles['title']}>{title}</h5>
			)}
		</FlexAppHeader>
	)
}

export default AsideHeader
